import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { createStructuredSelector } from 'reselect';
import { selectIsMultipleEnabled } from 'root/selectors';
import bindActions, { types as ats } from '../../actions';
import ContextItems from '../ContextItems';
import { selectHasMoreAssets, selectCurrentContext, selectFiltersPanelOpen } from '../../selectors';

export const SearchPage = (props) => {
  const { isFiltersPanelOpen } = props;

  const onLoadMore = () => {
    if (props.hasMoreAssets) {
      props.actions[ats.RETRIEVE_MORE_ASSETS]();
    }
  };

  return (
    <div
      className={cx('stage flex h-100 overflow-y-auto relative overlay-prevent-pointer-events', {
        'filter-panel-open': isFiltersPanelOpen,
      })}
    >
      <div className="h-100 w-100 overflow-auto">
        <ContextItems
          isMultiple={props.isMultiple}
          context={props.currentContext}
          onSelect={props.onSelect}
          onLoadMore={onLoadMore}
          hasMore={props.hasMoreAssets}
          isFiltersPanelOpen={isFiltersPanelOpen}
        />
      </div>
    </div>
  );
};

export default connect(
  createStructuredSelector({
    isMultiple: selectIsMultipleEnabled,
    currentContext: selectCurrentContext,
    isFiltersPanelOpen: selectFiltersPanelOpen,
    hasMoreAssets: selectHasMoreAssets,
  }),
  (dispatch) => ({
    actions: bindActions(dispatch),
  })
)(SearchPage);
